var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoupleUsersSilhouetteWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    style: {
      enableBackground: "new 0 0 88.71 88.709"
    },
    viewBox: "0 0 88.71 88.709",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "active-path",
    d: "M 49.044 24.514 c 0 -8.1 6.565 -14.666 14.666 -14.666 s 14.666 6.566 14.666 14.666 c 0 8.1 -6.565 14.666 -14.666 14.666 S 49.044 32.613 49.044 24.514 Z M 69.932 40.18 H 57.488 c -10.354 0 -18.777 8.424 -18.777 18.777 V 74.18 l 0.039 0.236 l 1.05 0.328 c 9.88 3.086 18.466 4.117 25.531 4.117 c 13.801 0 21.8 -3.936 22.294 -4.186 l 0.98 -0.498 l 0.104 0.001 V 58.958 C 88.71 48.604 80.287 40.18 69.932 40.18 Z M 25 39.18 c 8.1 0 14.666 -6.566 14.666 -14.666 c 0 -8.1 -6.566 -14.666 -14.666 -14.666 s -14.666 6.566 -14.666 14.666 C 10.334 32.614 16.9 39.18 25 39.18 Z M 35.326 74.18 V 58.958 c 0 -6.061 2.445 -11.55 6.385 -15.568 c -2.997 -2.025 -6.607 -3.209 -10.488 -3.209 H 18.778 C 8.424 40.18 0 48.604 0 58.958 V 74.18 l 0.039 0.236 l 1.051 0.328 c 9.879 3.086 18.465 4.117 25.531 4.117 c 4.493 0 8.359 -0.42 11.563 -0.99 l -2.422 -0.758 L 35.326 74.18 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupleUsersSilhouetteWhite);
export default __webpack_public_path__ + "static/media/couple-users-silhouette_WHITE.8391325a0a72a89ae461254ec214f5fd.svg";
export { ForwardRef as ReactComponent };